export const environment = {
  api_url: 'https://portalapi-dev.cascadedesigns.com',
};
